import { Spinner } from "@components/index";
import { OrderStatus } from "@interfaces/basket";
import { commafy } from "@lib/index";
import NoDataIcon from "assets/svg/no-data.svg";
import { useRouter } from "next/router";
import React, { FC } from "react";

import { convertMiladiToJalali } from "../../../../src/utils";

type Props = {
  data: any;
  isLoading: boolean;
};

export const getTextAndColorByEnum = (enumValue: number, isCancel: boolean) => {
  switch (true) {
    case enumValue === OrderStatus.Pending && !isCancel:
      return {
        text: "در انتظار پرداخت",
        class: "bg-[#556EE621]/20 text-[#556EE6C9]",
      };
    case enumValue === OrderStatus.Inprogress && !isCancel:
      return {
        text: "در انتظار پرداخت",
        class: "bg-[#556EE621]/20 text-[#556EE6C9]",
      };
    case enumValue === OrderStatus.Failed && !isCancel:
      return { text: "ناموفق", class: "bg-[#F46A6A]/20 text-[#F46A6A]" };
    case enumValue === OrderStatus.Success && !isCancel:
      return { text: "موفق", class: "bg-[#DAF4EB] text-[#34C38F]" };
    case enumValue === OrderStatus.Canceled && isCancel:
      return { text: "انصراف", class: "bg-[#F46A6A2E] text-[#F46A6A]" };
    case enumValue === OrderStatus.Success && isCancel:
      return { text: "موفق", class: "bg-[#DAF4EB] text-[#34C38F]" };
    case enumValue === OrderStatus.Inprogress && isCancel:
      return {
        text: "انصراف از پرداخت",
        class: "bg-[#FFA2352E] text-[#F1B44C]",
      };
    default:
      return null;
  }
};

const OrdersList: FC<Props> = ({ data, isLoading }) => {
  const { push } = useRouter();
  const handleClickItem = (
    status: number | string,
    id: number | string,
    isInstallment: boolean,
    isAdmin: boolean
  ) => {
    const searchParams = new URLSearchParams();
    let url = `/basket/${id}`;
    if (isInstallment) {
      url = `/basket/${id}/installment`;
    }
    searchParams.append("status", status.toString());
    if (isAdmin) {
      searchParams.append("isAdmin", "true");
    }
    push(`${url}?${searchParams}`);
  };
  return (
    <>
      <h2 className="mb-[12px] mr-[10px] mt-[5px] text-xs font-bold text-[#4A4A4A] md:text-base lg:text-lg">
        لیست سفارش‌های شما
      </h2>
      <table className="responsive-table">
        <thead>
          <tr>
            <th
              scope="col"
              className="md:w-[150px] md:!pr-4 xl:!pr-10 2xl:w-[200px]"
            >
              شماره پیگیری
            </th>
            <th scope="col">شرح خرید</th>
            <th scope="col" className="md:w-[120px] 2xl:w-[200px]">
              مبلغ <span className="font-medium">(تومان)</span>
            </th>
            <th scope="col" className="md:w-[120px] 2xl:w-[200px]">
              تاریخ
            </th>
            <th scope="col" className="!text-center md:w-[230px]">
              وضعیت
            </th>
          </tr>
        </thead>
        <tbody>
          {!isLoading ? (
            data && data?.orders && data?.orders.length ? (
              data.orders.map((item: any) => {
                return (
                  <tr
                    className="cursor-pointer"
                    onClick={() => {
                      if (
                        item?.status === OrderStatus.Pending &&
                        !item?.isInstallment
                      ) {
                        push(`/basket`);
                      } else if (
                        item?.status === OrderStatus.Success ||
                        item?.status === OrderStatus.Canceled
                      ) {
                        handleClickItem(
                          item?.status,
                          item?.id,
                          item?.isInstallment,
                          item?.isAdmin
                        );
                      }
                    }}
                    key={item?.id}
                  >
                    <td
                      data-label="شماره پیگیری:"
                      className="relative md:!pr-4 xl:!pr-10"
                    >
                      <span
                        className={`absolute left-0 top-[6px] inline-block h-min rounded-full px-7 py-1 md:hidden ${
                          getTextAndColorByEnum(item?.status, item?.isCancel)
                            ?.class
                        }`}
                      >
                        {
                          getTextAndColorByEnum(item?.status, item?.isCancel)
                            ?.text
                        }
                      </span>
                      {item?.id}-{item?.status}
                    </td>
                    <td data-label="شرح خرید:" style={{ paddingLeft: 20 }}>
                      {item?.description}
                    </td>
                    <td data-label="مبلغ (تومان):">{commafy(item?.price)}</td>
                    <td data-label="تاریخ:">
                      {convertMiladiToJalali(item?.createdDate)}
                    </td>
                    <td data-label="وضعیت:" className="!hidden md:!table-cell">
                      <div className="flex items-center gap-2">
                        <div className="w-[62px]">
                          {item?.isAdmin &&
                          item?.status === OrderStatus.Success ? (
                            <span className="h-min rounded-full bg-purple-100 px-4 py-1 text-purple-200">
                              ادمین
                            </span>
                          ) : undefined}
                        </div>
                        <span
                          className={`h-min rounded-full px-7 py-1 ${
                            getTextAndColorByEnum(item?.status, item?.isCancel)
                              ?.class
                          }`}
                        >
                          {
                            getTextAndColorByEnum(item?.status, item?.isCancel)
                              ?.text
                          }
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={5} className="!text-center">
                  <NoDataIcon className="-mt-5 inline-block h-[200px] w-full md:h-[40vh]" />
                  <p className="-mt-5 text-base text-[#4E4E56] md:-mt-8">
                    شما هنوز تراکنشی ثبت نکرده اید!
                  </p>
                </td>
              </tr>
            )
          ) : (
            <tr>
              <td colSpan={5}>
                <div className="py-20 text-center">
                  <Spinner className="mx-auto h-10 w-10 animate-opacity animate-fade-in-down" />
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default OrdersList;
